import { render, staticRenderFns } from "./OrderFormStep6PlacementRuleTab.module.vue?vue&type=template&id=2d31e764&scoped=true&"
import script from "./OrderFormStep6PlacementRuleTab.module.vue?vue&type=script&lang=js&"
export * from "./OrderFormStep6PlacementRuleTab.module.vue?vue&type=script&lang=js&"
import style0 from "./OrderFormStep6PlacementRuleTab.module.vue?vue&type=style&index=0&id=2d31e764&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d31e764",
  null
  
)

export default component.exports